export const ucFirst = (value: string): string => value.charAt(0).toUpperCase();
